import { CircleAlert } from "lucide-react";

type Props = {
  messageError?: string;
  isInvalid?: string | boolean | null;
};

export function MessageError({ messageError, isInvalid }: Props) {
  return messageError && isInvalid ? (
    <div className="w-full flex justify-start items-center gap-x-1">
      <CircleAlert size={14} className="text-red-500" />
      <span className="text-red-500 text-sm  p-0 m-0"> {messageError}</span>
    </div>
  ) : (
    <div className="min-h-3"></div>
  );
}
